export default __webpack_public_path__ + "static/image04-3494bdb0de993a15fc99a4373c276f9d.jpg";